<template>
  <div class="main_svv_search_form">
    <div class="svv_search_form">
      <div class="ais-InstantSearch">
        <ais-instant-search
          :search-client="searchClient"
          :index-name="indexName"
        >
          <ais-configure :filters="applyFillter()" :hitsPerPage="filterLimit" />
          <ais-autocomplete>
            <template v-slot="{ currentRefinement, indices, refine }">
              <div class="auto-suggestion">
                <div class="suggestion-inner">
                  <span class="dashicons dashicons-search"></span>

                  <input
                    id="search_input"
                    type="search"
                    :value="currentRefinement"
                    :placeholder="searchVal"
                    autocomplete="off"
                    @input="refine($event.currentTarget.value)"
                    v-on:keyup.enter="redirectTo(currentRefinement)"
                    v-on:keyup="selectList"
                  />
                </div>

                <div
                  id="listid"
                  class="search-Suggestion-list"
                  v-if="currentRefinement"
                >
                  <ul v-for="index in indices" :key="index.indexId">
                    <li v-show="index.hits.length == 0">
                      Inga resultat hittades för "<b>{{ currentRefinement }}</b
                      >"
                    </li>
                    <li
                      :atrd="hit.permalink"
                      v-for="(hit, k) in index.hits"
                      :key="hit.objectID"
                      :class="{ focus: k === focus }"
                    >
                      <div v-if="checktype(hit.post_type)">
                        <a
                          :href="
                            hit.permalink.replace(
                              '%area%',
                              hit.taxonomies['areas']
                            )
                          "
                          ><ais-highlight attribute="post_title" :hit="hit"
                        /></a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </ais-autocomplete>
        </ais-instant-search>
        <ais-instant-search
          :search-client="searchClient"
          :index-name="indexName"
          :search-function="searchFunction"
        >
          <div class="rigjt-panel">
            <ais-refinement-list attribute="taxonomies.areas">
              <div slot-scope="{ items }">
                <select
                  id="catgo"
                  @change="addClassls($event)"
                  :class="{ optionselected: isAddClass }"
                  v-model="selected"
                >
                  <option value="allcat">{{ categoryVal }}</option>
                  <option
                    v-for="item in items"
                    :key="item.value"
                    v-bind:value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </ais-refinement-list>
          </div>
        </ais-instant-search>
      </div>
    </div>
    <button @click="getCurrentSubmit()">{{ submitVal }}</button>
  </div>
</template>
<script>
/* global svvSearchForm */
/* eslint-disable vue/no-unused-components, prettier/prettier, no-console */
import Multiselect from 'vue-multiselect';
import { VueAutosuggest } from 'vue-autosuggest';
import algoliasearch from 'algoliasearch';

import { createBrowserXhrRequester } from '@algolia/requester-browser-xhr';

/**
 * We need to replace client completely, old injection doesn't work anymore
 * Also need to update plugin, since settings section name is changed
 * 
 * @returns {algoliasearch}
 */
const createSearchClient = () => {
    const localizedProxy = localize('svb_client_proxy');

    const clientProxy =
        typeof localizedProxy === 'string' && localizedProxy.length > 0
            ? localizedProxy
            : typeof window !== 'undefined' &&
                    window.algolia &&
                    typeof window.algolia.client_proxy === 'string'
              ? window.algolia.client_proxy
              : '';

    return algoliasearch(
        localize('svb_utbildningar_algolia_app') || '',
        localize('svb_utbildningar_algolia_api_key') || '',
        clientProxy
          ? {
              requester: {
                send(request) {
                  const requester = createBrowserXhrRequester();
                  const separator = clientProxy.includes('?') ? '&url=' : '?url=';

                  return requester.send({
                    ...request,
                    url: clientProxy + separator + request.url,
                  });
                },
              },
            }
          : undefined
    );
};

const localize = function (key) {
  if (typeof svvSearchForm === 'undefined') {
    return false;
  }

  if (typeof svvSearchForm[key] === 'undefined') {
    return false;
  }

  return svvSearchForm[key];
};

export default {
  components: {
    VueAutosuggest,
    Multiselect,
  },
  data() {
    return {
      searchClient: createSearchClient(),
      searchFunction(helper) {
        helper.search();
      },
      indexName: localize('svb_utbildningar_algolia_index') || '',
      currentRefinement: '',
      filterLimit: 5,
      no_results: localize('no_results') || '',
      searchVal: localize('searchVal') || 'Search',
      categoryVal: localize('categoryVal') || 'All Category',
      targetPage: localize('svb_target_url') || '',
      submitVal: localize('submitVal') || 'submit',
      focus: null,
      catgoryFillter: 'taxonomies.areas',
      selected: 'allcat',
      isAddClass: false,
    };
  },
  methods: {
    checktype(type) {
      if (type == 'utbildningar-course') {
        return true;
      }
    },
    applyFillter() {
      if (this.selected != 'allcat') {
        return 'taxonomies.areas:"' + this.selected + '"';
      }
    },
    addClassls(e) {
      if (e.target.value == 'allcat') {
        this.isAddClass = false;
      } else {
        this.isAddClass = true;
      }
    },
    redirectTo(q) {
      var focus = false;
      if (document.getElementsByClassName('focus').length > 0) {
        focus = document
          .getElementsByClassName('focus')[0]
          .getAttribute('atrd');
      }

      var query = '';
      if (focus) {
        window.location.href = focus;
      } else {
        let catgo = document.getElementById('catgo').value;
        if (catgo != 'allcat') {
          q += '&refinementList[taxonomies.areas]=' + catgo;
        }
        query = '?query=' + q;
        const newUrl = this.targetPage + encodeURI(query);
        window.location.href = newUrl;
      }
    },
    getCurrentSubmit() {
      let search_input = document.getElementById('search_input').value;
      let catgo = document.getElementById('catgo').value;
      // if(catgo=='allcat'){
      //   alert('Please select catagory');
      // }else{
      let query = '';

      if (catgo != 'allcat') {
        search_input += '&refinementList[taxonomies.areas]=' + catgo;
      }
      query = '?query=' + search_input;
      const newUrl = this.targetPage + encodeURI(query);
      window.location.href = newUrl;
      //}
    },
    transformItems(items) {
      console.log('ddddddddddddd', items);
    },
    selectList: function (e) {
      switch (e.keyCode) {
        case 38:
          if (this.focus === null) {
            this.focus = 0;
          } else if (this.focus > 0) {
            this.focus--;
          }
          break;
        case 40:
          if (this.focus === null) {
            this.focus = 0;
          } else if (this.focus < 6 - 1) {
            this.focus++;
          }
          break;
      }
    },
  },
};
</script>

<style lang="css">
.main_svv_search_form {
  padding-right: 0;
  position: relative;
  z-index: 0;
}
.svv_search_form {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  position: relative;
  flex-wrap: wrap;
  z-index: 9;
}
.svv_search_form > div {
  width: 100%;
  background: #fff;
  padding: 15px 20px;
  border-radius: 50px;
  margin-bottom: 15px;
}

.focus {
  background: #f6f6f6;
}
.suggestion-inner {
  display: flex;
  align-items: center;
}
.svv_search_form input {
  width: 100%;
  border: none;
  padding: 0px 10px;
  box-shadow: none;
  outline: none;
  background: #fff;
  color: #000;
}
.svv_search_form ::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #ccc;
}
.svv_search_form ::-moz-placeholder {
  /* Firefox 19+ */
  color: #ccc;
}
.svv_search_form :-ms-input-placeholder {
  /* IE 10+ */
  color: #ccc;
}
.svv_search_form :-moz-placeholder {
  /* Firefox 18- */
  color: #ccc;
}
.search-Suggestion-list a {
  text-decoration: none !important;
  color: #000 !important;
  font-family: auto;
}
.svv-search-form div {
  width: 100%;
}

/* .auto-suggestion {
    position: relative;
    z-index: 0px;
} */

.search-Suggestion-list {
  background: #fff;
  padding: 20px;
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 44px;
  z-index: 9999;
}

.search-Suggestion-list ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
  max-height: 400px;
  overflow: auto;
}

.search-Suggestion-list ul li {
  width: 100%;
  margin: 0px 0px 5px 0px;
  list-style: none;
}

.svv_search_form .svv_search_form {
  border-radius: 10px;
  padding: 15px 20px;
}
.svv_search_form .search-Suggestion-list {
  background: #fff;
  padding: 0;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 44px;
  z-index: 9999;
  width: 100%;
  border-radius: 10px;
}
.svv_search_form .search-Suggestion-list ul {
  list-style: none;
  margin: 0;
  padding: 10px 0;
  max-height: 400px;
  overflow: auto;
}
.svv_search_form .search-Suggestion-list ul li {
  width: 100%;
  margin: 0;
  list-style: none;
  padding: 5px 15px;
  font-size: 14px;
  line-height: normal;
}
.svv_search_form .search-Suggestion-list a {
  text-decoration: none !important;
  color: #000 !important;
}
.svv_search_form .mark,
.svv_search_form mark {
  padding: 0;
  color: #0075bf;
  background: transparent;
}
.svv_search_form .search-Suggestion-list {
  box-shadow: 0px 0px 2px #ccc;
  top: 60px;
}
.svv_search_form .rigjt-panel {
  width: 100%;
}

.svv_search_form .rigjt-panel select {
  background-color: none !important;
  border: none !important;
  width: 100%;
  outline: none !important;
  padding: 1px 10px !important;
  text-decoration: none !important;
  color: #ccc;
  font-size: 14px;
  background-image: url(./select-icon.png) !important;
  background-repeat: no-repeat !important;
  background-position: calc(100%) center !important;
  background-size: 11px auto !important;
  appearance: none !important;
}
.svv_search_form .rigjt-panel select option {
  color: #000;
}
.svv_search_form .rigjt-panel select.optionselected {
  color: #000;
}
.main_svv_search_form button {
  border: none;
  width: 100%;
  padding: 15px 5px;
  border-radius: 30px;
  background: #0075bf;
  color: #fff;
  text-transform: capitalize;
}

.main_svv_search_form button:hover {
  background: #025b93;
  color: #fff;
}
</style>
